import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    const personnelLinks = [
        { href: '/createpersonnel', icon: 'fa-address-card', label: 'Nouveau Personnel' },
        { href: '/personnel', icon: 'fa-archive', label: 'Liste Personnel' },
        { href: '/statisticsbyorganique', icon: 'fa-shield', label: 'C. Organique' },
        { href: '/statisticsbyoperationnel', icon: 'fa-adjust', label: 'Effectifs Opérationnels' },
    ];

    const organisationLinks = [
        { href: '/compagnie', icon: 'fa-building', label: 'Compagnie' },
        { href: '/bataillon', icon: 'fa-sitemap', label: 'Bataillon' },
        { href: '/brigade', icon: 'fa-sitemap', label: 'Brigade' },
        { href: '/listeboasss', icon: 'fa-shield', label: 'Liste Boa et DSS' },
    ];

    const ressourcesLinks = [
        { href: '/decoration', icon: 'fa-certificate', label: 'Honorifique' },
        { href: '/personnelsmilitaireretraite', icon: 'fa-wheelchair', label: 'Retraite militaire' },
        { href: '/personnelscivilretraite', icon: 'fa-wheelchair', label: 'Retraite civile' },
        { href: '/cartebrigademadagascar', icon: 'fa-map', label: 'Carte des brigades' },
    ];

    const year = new Date().getFullYear();

    return (
        <footer className="bg-gray-900 border-t border-gray-700 text-gray-300">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">

                    {/* Colonne 1 — Identité */}
                    <div className="lg:col-span-1">
                        <Link to="/" className="flex items-center gap-2 text-white hover:text-green-400 transition-colors duration-200">
                            <i className="fa fa-home fa-lg"></i>
                            <span className="text-sm font-semibold tracking-widest uppercase text-green-400">DCCA</span>
                        </Link>
                        <p className="mt-3 text-sm text-gray-400 leading-relaxed">
                            Direction de la Coordination et du Contrôle Administratif. Gestion centralisée des effectifs, des brigades et des ressources humaines.
                        </p>
                    </div>

                    {/* Colonne 2 — Personnel */}
                    <div>
                        <p className="text-xs font-semibold text-green-400 uppercase tracking-wider mb-3">Personnel</p>
                        <ul className="space-y-2">
                            {personnelLinks.map((item) => (
                                <li key={item.href}>
                                    <Link
                                        to={item.href}
                                        className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors duration-150"
                                    >
                                        <i className={`fa ${item.icon} text-green-400 w-4 text-center text-xs`}></i>
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Colonne 3 — Organisation */}
                    <div>
                        <p className="text-xs font-semibold text-green-400 uppercase tracking-wider mb-3">Organisation</p>
                        <ul className="space-y-2">
                            {organisationLinks.map((item) => (
                                <li key={item.href}>
                                    <Link
                                        to={item.href}
                                        className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors duration-150"
                                    >
                                        <i className={`fa ${item.icon} text-green-400 w-4 text-center text-xs`}></i>
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Colonne 4 — Ressources */}
                    <div>
                        <p className="text-xs font-semibold text-green-400 uppercase tracking-wider mb-3">Ressources</p>
                        <ul className="space-y-2">
                            {ressourcesLinks.map((item) => (
                                <li key={item.href}>
                                    <Link
                                        to={item.href}
                                        className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors duration-150"
                                    >
                                        <i className={`fa ${item.icon} text-green-400 w-4 text-center text-xs`}></i>
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Colonne 5 — Contact */}
                    <div>
                        <p className="text-xs font-semibold text-green-400 uppercase tracking-wider mb-3">Contact</p>
                        <p className="text-sm font-medium text-white mb-2">DCCA / INFOCOMM</p>
                        <ul className="space-y-2 text-sm text-gray-400">
                            <li className="flex items-center gap-2">
                                <i className="fa fa-globe text-green-400 w-4 text-center text-xs"></i>
                                <a href="https://dcca.mg" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-150">
                                    dcca.mg
                                </a>
                            </li>
                            <li className="flex items-center gap-2">
                                <i className="fa fa-envelope text-green-400 w-4 text-center text-xs"></i>
                                <a href="mailto:dccainfocomme2023@gmail.com" className="hover:text-white transition-colors duration-150">
                                    dccainfocomme2023@gmail.com
                                </a>
                            </li>
                            <li className="flex items-center gap-2">
                                <i className="fa fa-phone text-green-400 w-4 text-center text-xs"></i>
                                <a href="tel:0342442378" className="hover:text-white transition-colors duration-150">
                                    034 24 423 78
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>

                {/* Barre du bas */}
                <div className="mt-10 pt-6 border-t border-gray-700 flex flex-col sm:flex-row items-center justify-between gap-3">
                    <p className="text-xs text-gray-500">
                        &copy; {year} DCCA. Tous droits réservés.
                    </p>
                    <p className="text-xs text-gray-500">
                        Propulsé par INFOCOMM
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;